/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.37
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { EcoBalanceDetail } from '../model/models';
import { Problem } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class TripsV2Service {

    protected basePath = 'https://journey-service.api.sbb.ch';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get detailed eco-balance values for a given &#x60;Trip&#x60; (v2.TripV2::reconstructionContext or v3.Trip::id). The response is a Map(key&#x3D;PUBLIC_TRANSPORTATION|CAR|FLIGHT, value&#x3D;EcoBalanceDetail) to compare PT, Car or flight (if distance is far enough for a flight).
     * Determines comparable trips internally in relation to transportProduct and ecology-coefficants per key.&lt;br&gt;Check [Hafas Manual EcoParams](https://sbb.sharepoint.com/:b:/r/teams/297/Oeffentlich/S3_Programm/Anwendungen/Oeffentlich/KIP/Hafas/API/REST-Proxy/10_Dokumentation_ReST/HAFAS_ReST_Interface_EcoParams_v.1.4_sbb.pdf).
     * @param reconstructionContext &#x60;v3.Trip::id&#x60; is a temporary TripContext describing a concrete rideable and priceable journey (and not to be understood as a guaranteed ID which might be cached forever)! Therefore proper reconstruction is not guaranteed (realtime aspects, lacking service-days in the future, ..)!
     * @param acceptLanguage Language of translatable properties.
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param carClass Specifies the size of the vehicle.
     * @param carEngine Vehicle engine type.
     * @param carEuroNorm Emission standards for vehicle-engines.
     * @param carFuelType Fuel type, related to vehicle-engines.
     * @param carLoad Specifies the number of passengers in a vehicle.
     * @param flightFeeder Sets the means of transport for the route from the origin to the first airport and from the last airport to the destination. Emissions for flights with feeders using compareCarTrip or public transport (train) can be calculated.
     * @param flightLoad Degree of flight capacity utilization.
     * @param load Public transport load (air included): specifies the load in public transport.
     * @param publicTransportLoad Specifies the load in public transport as average.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTripsWithEcoBalanceByReconstructionContext(reconstructionContext: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', requestID?: string, carClass?: 'LOW_1' | 'LOW_2' | 'LOW_3' | 'MEDIUM_1' | 'MEDIUM_2' | 'MEDIUM_3' | 'HIGH_1' | 'HIGH_2' | 'HIGH_3' | 'VAN_1' | 'VAN_2' | 'VAN_3' | 'OFFROAD_1' | 'OFFROAD_2' | 'OFFROAD_3', carEngine?: 'AVG' | 'GAS_EURO3' | 'GAS_EURO4' | 'GAS_EURO5' | 'DIESEL_EURO3' | 'DIESEL_EURO4' | 'DIESEL_EURO5' | 'LPG_CONV', carEuroNorm?: 'AVG' | 'EURO3' | 'EURO4' | 'EURO5' | 'EURO6', carFuelType?: 'AVG' | 'GAS' | 'DIESEL' | 'LPG' | 'HYBRID' | 'PLUGIN' | 'ELECTRIC', carLoad?: 'AVG' | 'PASSENGER_1' | 'PASSENGER_2' | 'PASSENGER_3' | 'PASSENGER_4' | 'PASSENGER_5', flightFeeder?: 'CAR' | 'TRAIN', flightLoad?: 'AVG' | 'FULL', load?: 'AVG' | 'LOW' | 'MEDIUM' | 'HIGH', publicTransportLoad?: 'AVG' | 'FULL', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<{ [key: string]: EcoBalanceDetail; }>;
    public getTripsWithEcoBalanceByReconstructionContext(reconstructionContext: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', requestID?: string, carClass?: 'LOW_1' | 'LOW_2' | 'LOW_3' | 'MEDIUM_1' | 'MEDIUM_2' | 'MEDIUM_3' | 'HIGH_1' | 'HIGH_2' | 'HIGH_3' | 'VAN_1' | 'VAN_2' | 'VAN_3' | 'OFFROAD_1' | 'OFFROAD_2' | 'OFFROAD_3', carEngine?: 'AVG' | 'GAS_EURO3' | 'GAS_EURO4' | 'GAS_EURO5' | 'DIESEL_EURO3' | 'DIESEL_EURO4' | 'DIESEL_EURO5' | 'LPG_CONV', carEuroNorm?: 'AVG' | 'EURO3' | 'EURO4' | 'EURO5' | 'EURO6', carFuelType?: 'AVG' | 'GAS' | 'DIESEL' | 'LPG' | 'HYBRID' | 'PLUGIN' | 'ELECTRIC', carLoad?: 'AVG' | 'PASSENGER_1' | 'PASSENGER_2' | 'PASSENGER_3' | 'PASSENGER_4' | 'PASSENGER_5', flightFeeder?: 'CAR' | 'TRAIN', flightLoad?: 'AVG' | 'FULL', load?: 'AVG' | 'LOW' | 'MEDIUM' | 'HIGH', publicTransportLoad?: 'AVG' | 'FULL', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<{ [key: string]: EcoBalanceDetail; }>>;
    public getTripsWithEcoBalanceByReconstructionContext(reconstructionContext: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', requestID?: string, carClass?: 'LOW_1' | 'LOW_2' | 'LOW_3' | 'MEDIUM_1' | 'MEDIUM_2' | 'MEDIUM_3' | 'HIGH_1' | 'HIGH_2' | 'HIGH_3' | 'VAN_1' | 'VAN_2' | 'VAN_3' | 'OFFROAD_1' | 'OFFROAD_2' | 'OFFROAD_3', carEngine?: 'AVG' | 'GAS_EURO3' | 'GAS_EURO4' | 'GAS_EURO5' | 'DIESEL_EURO3' | 'DIESEL_EURO4' | 'DIESEL_EURO5' | 'LPG_CONV', carEuroNorm?: 'AVG' | 'EURO3' | 'EURO4' | 'EURO5' | 'EURO6', carFuelType?: 'AVG' | 'GAS' | 'DIESEL' | 'LPG' | 'HYBRID' | 'PLUGIN' | 'ELECTRIC', carLoad?: 'AVG' | 'PASSENGER_1' | 'PASSENGER_2' | 'PASSENGER_3' | 'PASSENGER_4' | 'PASSENGER_5', flightFeeder?: 'CAR' | 'TRAIN', flightLoad?: 'AVG' | 'FULL', load?: 'AVG' | 'LOW' | 'MEDIUM' | 'HIGH', publicTransportLoad?: 'AVG' | 'FULL', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<{ [key: string]: EcoBalanceDetail; }>>;
    public getTripsWithEcoBalanceByReconstructionContext(reconstructionContext: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', requestID?: string, carClass?: 'LOW_1' | 'LOW_2' | 'LOW_3' | 'MEDIUM_1' | 'MEDIUM_2' | 'MEDIUM_3' | 'HIGH_1' | 'HIGH_2' | 'HIGH_3' | 'VAN_1' | 'VAN_2' | 'VAN_3' | 'OFFROAD_1' | 'OFFROAD_2' | 'OFFROAD_3', carEngine?: 'AVG' | 'GAS_EURO3' | 'GAS_EURO4' | 'GAS_EURO5' | 'DIESEL_EURO3' | 'DIESEL_EURO4' | 'DIESEL_EURO5' | 'LPG_CONV', carEuroNorm?: 'AVG' | 'EURO3' | 'EURO4' | 'EURO5' | 'EURO6', carFuelType?: 'AVG' | 'GAS' | 'DIESEL' | 'LPG' | 'HYBRID' | 'PLUGIN' | 'ELECTRIC', carLoad?: 'AVG' | 'PASSENGER_1' | 'PASSENGER_2' | 'PASSENGER_3' | 'PASSENGER_4' | 'PASSENGER_5', flightFeeder?: 'CAR' | 'TRAIN', flightLoad?: 'AVG' | 'FULL', load?: 'AVG' | 'LOW' | 'MEDIUM' | 'HIGH', publicTransportLoad?: 'AVG' | 'FULL', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {
        if (reconstructionContext === null || reconstructionContext === undefined) {
            throw new Error('Required parameter reconstructionContext was null or undefined when calling getTripsWithEcoBalanceByReconstructionContext.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (carClass !== undefined && carClass !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>carClass, 'carClass');
        }
        if (carEngine !== undefined && carEngine !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>carEngine, 'carEngine');
        }
        if (carEuroNorm !== undefined && carEuroNorm !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>carEuroNorm, 'carEuroNorm');
        }
        if (carFuelType !== undefined && carFuelType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>carFuelType, 'carFuelType');
        }
        if (carLoad !== undefined && carLoad !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>carLoad, 'carLoad');
        }
        if (flightFeeder !== undefined && flightFeeder !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>flightFeeder, 'flightFeeder');
        }
        if (flightLoad !== undefined && flightLoad !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>flightLoad, 'flightLoad');
        }
        if (load !== undefined && load !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>load, 'load');
        }
        if (publicTransportLoad !== undefined && publicTransportLoad !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>publicTransportLoad, 'publicTransportLoad');
        }

        let headers = this.defaultHeaders;
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }

        let credential: string | undefined;
        // authentication (BearerAuth) required
        credential = this.configuration.lookupCredential('BearerAuth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<{ [key: string]: EcoBalanceDetail; }>(`${this.configuration.basePath}/b2c/v2/trips/ecoBalance/${encodeURIComponent(String(reconstructionContext))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
